export class NotificationArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreJobFailed",
            "baseName": "restoreJobFailed",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "restoreJobRejected",
            "baseName": "restoreJobRejected",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "restoreJobSucceeded",
            "baseName": "restoreJobSucceeded",
            "type": "JobSucceededNotificationArguments",
            "format": ""
        },
        {
            "name": "backupJobFailed",
            "baseName": "backupJobFailed",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "backupJobRejected",
            "baseName": "backupJobRejected",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "backupJobSkipped",
            "baseName": "backupJobSkipped",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "backupJobSucceeded",
            "baseName": "backupJobSucceeded",
            "type": "JobSucceededNotificationArguments",
            "format": ""
        },
        {
            "name": "snapshotAccessDenied",
            "baseName": "snapshotAccessDenied",
            "type": "SnapshotAccessDeniedNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountCreated",
            "baseName": "cloudAccountCreated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountUpdated",
            "baseName": "cloudAccountUpdated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountDeleted",
            "baseName": "cloudAccountDeleted",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountDeactivated",
            "baseName": "cloudAccountDeactivated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "cloudAccountActivated",
            "baseName": "cloudAccountActivated",
            "type": "CloudAccountNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyApplied",
            "baseName": "backupPolicyApplied",
            "type": "BackupPolicyAppliesNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyUnApplied",
            "baseName": "backupPolicyUnApplied",
            "type": "BackupPolicyAppliesNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyCreated",
            "baseName": "backupPolicyCreated",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyUpdated",
            "baseName": "backupPolicyUpdated",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "backupPolicyDeleted",
            "baseName": "backupPolicyDeleted",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "backupVaultCreated",
            "baseName": "backupVaultCreated",
            "type": "VaultNotificationArguments",
            "format": ""
        },
        {
            "name": "backupVaultDeleted",
            "baseName": "backupVaultDeleted",
            "type": "VaultNotificationArguments",
            "format": ""
        },
        {
            "name": "resourceExcludedFromRansomwareDetection",
            "baseName": "resourceExcludedFromRansomwareDetection",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareDetectionExclusionCanceled",
            "baseName": "ransomwareDetectionExclusionCanceled",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareDetectedInResource",
            "baseName": "ransomwareDetectedInResource",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareDetectedInSnapshot",
            "baseName": "ransomwareDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "ransomwareInfectionRemediated",
            "baseName": "ransomwareInfectionRemediated",
            "type": "RansomwareResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "violationsDetected",
            "baseName": "violationsDetected",
            "type": "ViolationsDetectionNotificationArguments",
            "format": ""
        },
        {
            "name": "violationsResolved",
            "baseName": "violationsResolved",
            "type": "ViolationsDetectionNotificationArguments",
            "format": ""
        },
        {
            "name": "issueMuted",
            "baseName": "issueMuted",
            "type": "IssueMutedNotificationArguments",
            "format": ""
        },
        {
            "name": "issueUnmuted",
            "baseName": "issueUnmuted",
            "type": "IssueMutedNotificationArguments",
            "format": ""
        },
        {
            "name": "jobMetricsReportFailed",
            "baseName": "jobMetricsReportFailed",
            "type": "JobMetricsReportFailedArguments",
            "format": ""
        },
        {
            "name": "classificationJobFailed",
            "baseName": "classificationJobFailed",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationJobRejected",
            "baseName": "classificationJobRejected",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationJobSkipped",
            "baseName": "classificationJobSkipped",
            "type": "JobFailedNotificationArguments",
            "format": ""
        },
        {
            "name": "creditsNotification",
            "baseName": "creditsNotification",
            "type": "CreditsNotificationArguments",
            "format": ""
        },
        {
            "name": "creditsMonthlyUsageNotification",
            "baseName": "creditsMonthlyUsageNotification",
            "type": "CreditsMonthlyUsageNotificationArguments",
            "format": ""
        },
        {
            "name": "malwareDetectedInSnapshot",
            "baseName": "malwareDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "dataAnomalyDetectedInSnapshot",
            "baseName": "dataAnomalyDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "malwareRemediated",
            "baseName": "malwareRemediated",
            "type": "SecurityResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "dataAnomalyRemediated",
            "baseName": "dataAnomalyRemediated",
            "type": "SecurityResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "aiDataRiskDetectedInSnapshot",
            "baseName": "aiDataRiskDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "dataExposureRiskDetectedInSnapshot",
            "baseName": "dataExposureRiskDetectedInSnapshot",
            "type": "SecuritySnapshotNotificationArguments",
            "format": ""
        },
        {
            "name": "aiDataRiskRemediated",
            "baseName": "aiDataRiskRemediated",
            "type": "SecurityResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "dataExposureRiskRemediated",
            "baseName": "dataExposureRiskRemediated",
            "type": "SecurityResourceNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestPendingApproval",
            "baseName": "mpaRequestPendingApproval",
            "type": "MPARequestNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestApproved",
            "baseName": "mpaRequestApproved",
            "type": "MPAReviewNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestDenied",
            "baseName": "mpaRequestDenied",
            "type": "MPAReviewNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestPartiallyApproved",
            "baseName": "mpaRequestPartiallyApproved",
            "type": "MPAReviewNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestExecuted",
            "baseName": "mpaRequestExecuted",
            "type": "MPARequestNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestExpired",
            "baseName": "mpaRequestExpired",
            "type": "MPARequestNotificationArguments",
            "format": ""
        },
        {
            "name": "mpaRequestCancelled",
            "baseName": "mpaRequestCancelled",
            "type": "MPARequestNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationPolicyCreated",
            "baseName": "classificationPolicyCreated",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationPolicyUpdated",
            "baseName": "classificationPolicyUpdated",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationPolicyDeleted",
            "baseName": "classificationPolicyDeleted",
            "type": "BackupPolicyNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationPolicyApplied",
            "baseName": "classificationPolicyApplied",
            "type": "BackupPolicyAppliesNotificationArguments",
            "format": ""
        },
        {
            "name": "classificationPolicyUnapplied",
            "baseName": "classificationPolicyUnapplied",
            "type": "BackupPolicyAppliesNotificationArguments",
            "format": ""
        },
        {
            "name": "gdsgOperationalNotification",
            "baseName": "gdsgOperationalNotification",
            "type": "GdsgOperationalNotificationArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
